import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { stylesConstants } from '../../../styles/stylesConstants';
import { themeColors } from '../../../styles/themeColors';

export default makeStyles((theme: Theme) => ({
  container: {
    backgroundColor: themeColors.secondary,
    overflowY: 'hidden',
  },

  row: {
    '&:hover': {
      backgroundColor: themeColors.hoverListItem,
    },
  },

  cell: {
    fontWeight: 600,
    padding: 16,
    zIndex: 10,
    position: 'relative',
    // pointerEvents: 'none',
  },
}));
